/**
 *
 * VisitorLogsPage12970 Page constants
 *
 */

export const RECEPTION_VISITOR_LOGS_DX_GRID = 'ReceptionVisitorLogsDxGrid';
